import * as TYPES from './types';
import {
  pushPermission,
  removePermission,
  clearPermission,
} from '../permission/actions';
import { getMarkActionPermission } from '@ohif/viewer/src/appExtensions/Mark/api';

export const setIsHide = (stateKey, payload) => {
  return {
    type: TYPES.SET_IS_HIDE,
    stateKey,
    payload,
  };
};

export const setHideData = payload => ({ type: TYPES.SET_HIDE_DATA, payload });

export const setMarkList = payload => ({ type: TYPES.SET_MARK_LIST, payload });

export const setActiveMarkUUID = payload => ({
  type: TYPES.SET_ACTIVE_MARK_UUID,
  payload,
});

export const setPagination = payload => ({
  type: TYPES.SET_PAGINATION,
  payload,
});

export const setActiveContextMenuType = (payload = null) => ({
  type: TYPES.SET_ACTIVE_CONTEXT_MENU_TYPE,
  payload,
});

// 获取标注操作权限
export const getMarkPermissions = (caseId, type) => dispatch =>
  getMarkActionPermission({
    caseId,
  }).then(res => {
    // 添加权限
    if (!res.data) return;
    const permissions = res.data.actions;
    const data = 'markTask_' + caseId;
    const menu = 'markTask_' + type;
    dispatch(clearPermission({ data }));
    // 添加用户角色权限
    dispatch(pushPermission({ menu, role: res.data.userType, data }));
    // 添加是否能编辑标注权限
    if (res.data.showButton)
      dispatch(pushPermission({ menu, action: 'showButton', data }));
    // 添加按钮权限
    permissions.forEach(item => {
      const { available, actionId } = item;
      const handleAction = available ? pushPermission : removePermission;
      dispatch(handleAction({ menu, action: actionId, data, payload: item }));
    });
  });

export const setMarkUsers = payload => ({
  type: TYPES.SET_MARK_USERS,
  payload,
});

export const setMarkState = (
  payload = [TYPES.MARK_STATE.ALLOW_ALL, TYPES.MARK_STATE.ENABLED_EDIT]
) => {
  if (!Array.isArray(payload)) payload = [payload];
  return {
    type: TYPES.SET_MARK_STATE,
    payload: payload.reduce((acc, item) => acc | item),
  };
};
